import type {
  UpdateInvoiceDataApprovedResponse,
  UpdateInvoiceDataApprovedVariables,
} from './types';

import { ENDPOINT } from '~/constants/endpoints';

import { vestigasApi } from '~/services/kyClient';

import { zodInvoiceDetailSchema } from '../useQueryInvoiceDetail/validations';

import { zodUpdateInvoiceDataApprovedPayloadSchema } from './validations';

/**
 * Saves approved invoice totals.
 *
 * @param variables - Invoice and the approved totals to save.
 * @returns The invoice detail after the update.
 * @see https://app.dev.vestigas.com/redoc#tag/Invoices/operation/update_invoice_data_approved_invoices__invoice_id__data_approved_patch
 */
export async function updateInvoiceDataApproved({
  invoiceId,
  payload,
}: UpdateInvoiceDataApprovedVariables) {
  return vestigasApi
    .patch(ENDPOINT.INVOICE.UPDATE_DATA_APPROVED(invoiceId), {
      json: payload,
      validate: {
        body: zodUpdateInvoiceDataApprovedPayloadSchema,
        isResponseSensitive: true,
        response: zodInvoiceDetailSchema,
      },
    })
    .json<UpdateInvoiceDataApprovedResponse>();
}
